var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertProfileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 0.00216675C25.25 0.270696 0 25.6866 0 57.0001C0 88.4803 25.5198 114 57 114C88.3134 114 113.729 88.75 113.998 57.5H110.998C110.729 87.0931 86.6566 111 57 111C27.1766 111 3 86.8234 3 57C3 27.3435 26.9069 3.27072 56.5 3.00229V0.00216675Z",
    fill: "url(#paint0_linear_1_5194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57.5C114 58.3284 113.328 59 112.5 59C111.672 59 111 58.3284 111 57.5C111 56.6716 111.672 56 112.5 56C113.328 56 114 56.6716 114 57.5Z",
    fill: "url(#paint1_linear_1_5194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1.5C58 2.32843 57.3284 3 56.5 3C55.6716 3 55 2.32843 55 1.5C55 0.671573 55.6716 0 56.5 0C57.3284 0 58 0.671573 58 1.5Z",
    fill: "url(#paint2_linear_1_5194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5194",
    x1: 57,
    y1: 0,
    x2: 57,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353FD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5194",
    x1: 57,
    y1: 0,
    x2: 57,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353FD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5194",
    x1: 57,
    y1: 0,
    x2: 57,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353FD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertProfileBg);
export default __webpack_public_path__ + "static/media/expert_profile_bg.d7158b8a0d788adb90dd0946bf855918.svg";
export { ForwardRef as ReactComponent };